import React, { useEffect, useState } from 'react'
import { api } from '@api/index'
import { FieldValues, useForm } from 'react-hook-form'
import {
  QueryFunctionContext,
  useMutation,
  useQuery,
  useQueryClient,
} from 'react-query'
import BaseTable from '@components/shared/BaseTable'
import usePagenation from '@hooks/usePagenation'
import uuid from 'react-uuid'
import {
  StTempButtonArea,
  StResultTableWrapper,
  StTempPagenation,
} from './style'
import useModal from '@hooks/useModal'
import AddVideoModal from '@components/media/AddVideoModal'
import MessageModal from '@components/shared/MessageModal'
import { Message } from '@utils/message'

const rowSize = 8

const fetchVideoList = ({ queryKey }: QueryFunctionContext) => {
  const [_, page] = queryKey
  return api.mediaService.getMediaList({
    type: 'URL',
    size: rowSize,
    page: (page as number) - 1, //서버측 pageIndex는 0부터 시작
    sort: 'id,desc',
  })
}

const MediaVideo = () => {
  const [isAllCheck, setIsAllCheck] = useState(false)
  const queryClient = useQueryClient()
  const [openVideoModal] = useModal({ reactQuery: true })
  const [openResModal] = useModal()

  const { setValue, handleSubmit, register } = useForm({ mode: 'onChange' })

  const {
    pagelist,
    currentPage,
    goBeforeSection,
    goNextSection,
    goFirstSection,
    goNext,
    goBefore,
    setListRefIndex,
    setTotalPage,
  } = usePagenation(5)

  const {
    isLoading,
    error,
    data: { totalPages, content } = {} as MediaPagenationInfo,
  } = useQuery(['MediaVideo', currentPage], fetchVideoList, {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setTotalPage(data.totalPages)
    },
  })

  useEffect(() => {
    const nextPage = currentPage + 1
    if (nextPage > totalPages) return
    queryClient.prefetchQuery(['MediaVideo', nextPage], fetchVideoList)
  }, [currentPage, queryClient, totalPages])

  const deleteVideoMutation = useMutation(
    (ids: number[]) => api.mediaService.deleteMedia({ ids }),
    {
      onError: () => {},
      onSuccess: () => {
        queryClient.prefetchQuery(['MediaVideo', currentPage], fetchVideoList)
        setIsAllCheck(false)
      },
    }
  )
  const handleDeleteSubmit = async (formData: FieldValues) => {
    const isSomeChecked = Object.entries(formData).some(([_, value]) => value)
    if (!isSomeChecked) return
    const res = await openResModal(
      <MessageModal mode="req">{Message.question.DELETE_VIDEO}</MessageModal>
    )
    if (!res) return
    const ids = Object.entries(formData)
      .filter(([_, checked]) => checked)
      .map(([id, _]) => Number(id))
    if (ids.length) {
      deleteVideoMutation.mutate(ids)
    }
  }

  const handleCheckAll = (e: any) => {
    const isChecked = e.target.checked
    if (isChecked) {
      content?.forEach((element) => {
        setValue(element.id + '', true)
      })
      setIsAllCheck(true)
    } else {
      content?.forEach((element) => {
        setValue(element.id + '', false)
      })
      setIsAllCheck(false)
    }
  }

  const handleVideoAdd = async () => {
    const modalRes = await openVideoModal(<AddVideoModal />)
    if (modalRes) {
      queryClient?.invalidateQueries(['MediaVideo', 1])
      setListRefIndex(0)
      goFirstSection()
    }
  }

  return (
    <>
      <StResultTableWrapper>
        <StTempButtonArea>
          <div>미디어 관리</div>
          <button onClick={handleVideoAdd} className="button base">
            추가
          </button>
          <button className="button base" form="delete-file-form" key="submit">
            삭제
          </button>
        </StTempButtonArea>
        <form id="delete-file-form" onSubmit={handleSubmit(handleDeleteSubmit)}>
          <BaseTable
            column={[
              [
                <input
                  className=""
                  type="checkbox"
                  key={uuid()}
                  checked={isAllCheck}
                  onChange={handleCheckAll}
                />,
                3,
              ],
              ['번호', 5],
              ['파일명', 5],
              ['URL 주소', 10],
              ['업로드 날짜', 7],
            ]}
          >
            {content?.map(({ id, title, url, createdAt }, idx) => (
              <tr key={id}>
                <td>
                  <input
                    {...register(id + '')}
                    type="checkbox"
                    name={id + ''}
                  ></input>
                </td>
                <td>{idx + 1 + (currentPage - 1) * rowSize}</td>
                <td>{title}</td>
                <td>
                  <a href={url}>{url}</a>
                </td>
                <td>{createdAt.slice(0, 11)}</td>
              </tr>
            ))}
          </BaseTable>
          <StTempPagenation>
            <button
              type="button"
              className="button base"
              onClick={goBeforeSection}
            >
              {'<<'}
            </button>
            <button type="button" className="button base" onClick={goBefore}>
              {'<'}
            </button>
            {pagelist.map((num, idx) => (
              <button
                type="button"
                className="button base"
                onClick={() => setListRefIndex(idx)}
                key={num}
              >
                {num}
              </button>
            ))}
            <button type="button" className="button base" onClick={goNext}>
              {'>'}
            </button>
            <button
              type="button"
              className="button base"
              onClick={goNextSection}
            >
              {'>>'}
            </button>
          </StTempPagenation>
        </form>
      </StResultTableWrapper>
    </>
  )
}

export default MediaVideo
